module.exports = __webpack_public_path__ + "img/2.851436c6.jpg";